import './GrandInstitutional.css'

import forvetLogo from '../../../assets/forvet_logo.svg'
import IPG_LOGO from '../../../assets/grand/ipg_blanco_transparent.png'

export default function GrandInstitutional() {

    return (
        <section className='main-layout-section GrandInstitutional-main-container' id='alianza'>
            <figure className='GrandInstitutional--logos-container'>
                <img src={forvetLogo} alt='Forvet Logo' className='GrandInstitutional--logoImage' />
                <img src={IPG_LOGO} alt='GranD Logo' className='GrandInstitutional--logoImage' />
            </figure>

            <div>
                <h2 className='GrandInstitutional--title'>Una iniciativa desarrollada por <strong>FORVET</strong>,<br /> en colaboración estratégica con <strong>IPG IRIBARREN</strong>.</h2>
                <p className='GrandInstitutional--title '>Una unidad de formación para <strong style={{ color: "var(--color-grand-accent)" }}>potenciar</strong> el conocimiento <strong style={{ color: "var(--color-grand-accent)" }}>técnico, ético y práctico</strong> de profesionales del <strong style={{ color: "var(--color-grand-accent)" }}>campo veterinario</strong></p>

            </div>
        </section>
    )
}